import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const RedirectToDefaultTree: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to the default tree
        navigate('/tree/tekken-8', { replace: true });
    }, [navigate]);

    return <div>Redirecting to default tree...</div>;
};
